import { render, staticRenderFns } from "./ModalAvoid.vue?vue&type=template&id=15d36afe&scoped=true"
import script from "./ModalAvoid.vue?vue&type=script&lang=js"
export * from "./ModalAvoid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d36afe",
  null
  
)

export default component.exports